goog.provide('el8.ext.ModalDialog');

goog.require('el8.model.base');
goog.require('el8.uiwidget.NewDialog');


el8.ext.ModalDialog = function() {
    el8.uiwidget.NewDialog.apply(this, arguments);
};
el8.ext.ModalDialog.inheritsFrom(el8.uiwidget.NewDialog);

el8.ext.ModalDialog.prototype._init = function() {
    el8.uiwidget.NewDialog.prototype._init.call(this);
    var $input = $('<input>').attr('name', 'esc').outerWidth(1).height(1);
    this._contentElt.append($input);
    this.getDialogContainer().addClass('el8OBDialog');
};

el8.ext.ModalDialog.prototype.show = function() {
    el8.uiwidget.NewDialog.prototype.show.call(this);
    $(':input[name="esc"]', this.getContentElt()).focusFocus();
    var that = this;
    $(document).on('click', '.ui-widget-overlay',  function(e) {
        that.hide();
    });
};
el8.ext.ModalDialog.prototype.hide = function() {
    el8.uiwidget.NewDialog.prototype.hide.call(this);
    $(document).off('click', '.ui-widget-overlay');
};
